module.exports = __webpack_public_path__ + "static/media/campus-party.62e8ee0f.webp";